const White = require('./white');
const Black = require('./black');
const Default = require('./default');
const Blue = require('./blue');
const Gray = require('./gray');

module.exports = {
  White,
  Black,
  Default,
  Blue,
  Gray,
};
